<template>
  <div class="statistic-detail-table">
    <el-table
      ref="table"
      :key="tableKey"
      :data="rows"
      border
      size="mini"
      height="100%"
      :empty-text="emptyText"
      :span-method="spanMethod"
    >
      <el-table-column
        prop="categoryName"
        :label="categoryLabel"
        fixed="left"
        width="120"
        align="center"
        :formatter="formatCategory"
        show-overflow-tooltip
      />
      <el-table-column
        v-for="date in normalizedDates"
        :key="date"
        :prop="date"
        :label="date"
        align="center"
        min-width="110"
        :formatter="formatValue"
      />
      <el-table-column
        v-if="showTotalColumn"
        prop="total"
        :label="totalLabel"
        align="center"
        min-width="90"
        :formatter="formatValue"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'StatisticDetailTable',
  props: {
    dates: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    showTotalColumn: {
      type: Boolean,
      default: false
    },
    mergeGrandTotalRow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    normalizedDates() {
      return this.dates.map(date => String(date))
    },
    tableKey() {
      return this.normalizedDates.join('|') + '_' + this.rows.length
    }
  },
  data() {
    return {
      categoryLabel: '\u7c7b\u522b\u540d\u79f0',
      totalLabel: '\u5408\u8ba1',
      emptyText: '\u6682\u65e0\u6570\u636e'
    }
  },
  watch: {
    dates: {
      handler() {
        this.refreshLayout()
      },
      deep: true
    },
    rows: {
      handler() {
        this.refreshLayout()
      },
      deep: true
    }
  },
  methods: {
    formatCategory(row) {
      return row.categoryName || row.category || row.name || ''
    },
    formatValue(row, column, cellValue) {
      if (this.mergeGrandTotalRow && row.rowType === 'grandTotal' && column.property !== 'categoryName') {
        return row.total == null ? 0 : row.total
      }
      return cellValue == null ? '' : cellValue
    },
    spanMethod({ row, columnIndex }) {
      if (!this.mergeGrandTotalRow || row.rowType !== 'grandTotal') {
        return [1, 1]
      }
      if (columnIndex === 0) {
        return [1, 1]
      }
      if (columnIndex === 1) {
        return [1, this.normalizedDates.length + (this.showTotalColumn ? 1 : 0)]
      }
      return [0, 0]
    },
    refreshLayout() {
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.statistic-detail-table {
  width: 100%;
  height: 100%;
}

.statistic-detail-table .el-table,
.statistic-detail-table .el-table__expanded-cell {
  color: #fff;
  background: transparent;
}

.statistic-detail-table .el-table th,
.statistic-detail-table .el-table tr,
.statistic-detail-table .el-table td {
  background: rgba(6, 48, 88, 0.72);
}

.statistic-detail-table .el-table th.is-leaf,
.statistic-detail-table .el-table td {
  border-color: rgba(53, 189, 219, 0.35);
}

.statistic-detail-table .el-table--border,
.statistic-detail-table .el-table--group {
  border-color: rgba(53, 189, 219, 0.35);
}

.statistic-detail-table .el-table__body tr:hover > td {
  background: rgba(0, 192, 249, 0.18);
}

.statistic-detail-table .el-table__empty-text {
  color: rgba(255, 255, 255, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/StatisticDetailTable.vue